export const handleLocaleFormat = (locale) => {
    return locale.replace(/-/g, '_');
  }